/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useReducer, useState, } from "react";
import { RuleReducer } from "./misc/RuleReducer";
import AppSettings from "../../../Settings/AppSettings";
import { AppContext } from "../../../Context/AppContext";
import Utils from "../../../Common/Utils";
import { CBI_RULE, CBM_RULE } from "./misc/RuleObjectTypes";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import { CBA_RULE, SELECT_ATTRIBUTE } from "./Components/RuleConstants";

export const RulesContext = createContext(undefined);

export const RulesContextProvider = ({ children }) => {
  const appData = useContext(AppContext);
  const [pageNumbers, setPageNumbers] = useState({ leftAttributeValues: [], rightAttributeValues: [] });
  const industryId = appData.get_selected_industry() && appData.get_selected_industry().id;
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [ruleState, ruleDispatch] = useReducer(RuleReducer, { rule: [] });
  const [ruleType, setRuleType] = useState(null);
  const [cellStates, setCellStates] = useState({});
  const [cbmRuleId, setCbmRuleId] = useState('');
  const [compatibilityData, setCompatibilityData] = useState([]);
  const [loadMasterdata, setLoadMasterdata] = useState(false);

  const [selectedCategories, setSelectedCategories] = useState({ leftCategory: { id: null, name: null }, rightCategory: { id: null, name: null }, });
  const [selectedAttributes, setSelectedAttributes] = useState({ leftAttribute: { id: null, name: null }, rightAttribute: { id: null, name: null }, });
  const [categoriesList, setCategoriesList] = useState([]);
  const [categoryTypesList, setCategoryTypesList] = useState([]);
  const [attributesList, setAttributesList] = useState({ leftAttributes: null, rightAttributes: null, });
  const [CBMOptions, setCBMOptions] = useState({ leftCatListOption: "", rightCatListOption: "", leftCatAttributeSet: [], rightCatAttributeSet: [], leftCatProductList: [], rightCatProductList: [], leftAttributeValues: [], rightAttributeValues: [], leftValuesAttr: "", leftValuesAttrName: "", rightValuesAttr: "", rightValuesAttrName: "", leftAttributeValueName: '', leftAttributeValueId: '', rightAttributeValueName: '', rightAttributeValueId: '', defaultCompatibilityValue: "", compatibilityLevel: "level4", showWarningModal: false, editMode: false, toggleSelectInput: false, showWarninModal: false, leftCatID: "", rightCatID: "", selectedCell: {}, valueToBeSaved: "", isProductFilter: false });
  
  const [paginationParams, setPaginationParams] = useState({pageNumber: 1, pageSize: 20});
  const [Loading, setLoading] = useState({ status: "", message: "", });
  const [hasMoreRow, setHasMoreRow] = useState(true);
  const [hasMoreColumn, setHasMoreColumn] = useState(true);
  const [totalRecords, setTotalRecords] = useState({ leftAttributeValues: 0, rightAttributeValues: 0 });
  const [initialRuleDetails, setInitialRuleDetails] = useState(null);


  useEffect(() => {
    getCategoryTypes();
    getCategories();
  }, [industryId]);

  const getCategoryTypes = async () => {
    setLoadMasterdata(false);
    try {
      let res = await ServiceWrapper.doGet( `${api_base_url}categorytype/getbyindustryid/${industryId}`, null, null, AuthManager.getGmsToken() );
      if (!res.errorfound) {
        setCategoryTypesList(res.data.data);
        setLoadMasterdata(true);
      } else {
        setLoadMasterdata(true);
      }
    } catch (error) {
      setLoadMasterdata(true);
    }
  }

  const resetPageNumbersAndColumnAndRow = () => {
    // setPageNumbers({ leftAttributeValues: [], rightAttributeValues: [] });
    // setHasMoreColumn(true);
    // setHasMoreRow(true)
    // setCBMOptions((prev) => ({
    //   ...prev,
    //   rightCatProductList: [],
    //   leftCatProductList: []
    // }));
  };

  const shouldLoadProducts = () => {
    const areAttributesSelected = CBMOptions.rightAttributeValueId !== "" && CBMOptions.leftAttributeValueId !== "";
    const areAttributesValid = (CBMOptions.leftValuesAttr !== "" || CBMOptions.rightValuesAttr !== SELECT_ATTRIBUTE) && (CBMOptions.rightValuesAttr !== "" || CBMOptions.rightValuesAttr !== SELECT_ATTRIBUTE);
    return areAttributesSelected && areAttributesValid && ruleType === CBM_RULE && CBMOptions.leftCatListOption === 'products' && CBMOptions.isProductFilter !== undefined && CBMOptions.isProductFilter;
  };

  const addToList = (type, value) => {
    setPageNumbers(prevLists => ({
      ...prevLists,
      [type]: [...prevLists[type], value]
    }));
  }

  const isPageNumberPresent =(type, value) => {
    const numberList = pageNumbers[type];
    if (!numberList) {
        return false;
    }
    return numberList.includes(value);
  }

  useEffect(() => {
    if (ruleType === CBM_RULE && CBMOptions.leftCatListOption === 'values') {
      setAttributeValues();
    } 
  }, [CBMOptions.leftValuesAttr, CBMOptions.rightValuesAttr, CBMOptions.leftCatListOption, paginationParams, ruleType]);

  const setAttributeValues = async () => {
    if (CBMOptions.leftValuesAttr && CBMOptions.rightValuesAttr && CBMOptions.rightValuesAttr !== SELECT_ATTRIBUTE && CBMOptions.leftValuesAttr !== SELECT_ATTRIBUTE) {
      //if (hasMoreRow && !isPageNumberPresent('leftAttributeValues', paginationParams?.pageNumber)) {
        await fetchAndSetAttributeValues(CBMOptions.leftValuesAttr, 'leftAttributeValues');
        await fetchAndSetAttributeValues(CBMOptions.rightValuesAttr, 'rightAttributeValues');
      // if (hasMoreRow) {
        //addToList('leftAttributeValues', paginationParams?.pageNumber);
      // }
      //if (hasMoreColumn && !isPageNumberPresent('rightAttributeValues', paginationParams?.pageNumber)) {
      // if (hasMoreColumn) {
         //addToList('rightAttributeValues', paginationParams?.pageNumber);
      // }
    }
  };

  const fetchAndSetAttributeValues = async (attributeId, target) => {
    if (!attributeId) return;
    try {
      const attributeValues = await getAttributeValues(attributeId, target);
      setCBMOptions((prevState) => {
        return {
          ...prevState,
          [target]: target === 'leftAttributeValues' ? [...attributeValues] : [...attributeValues]
        };
      });
    } catch (error) {
      console.error('Error fetching attribute values:', error);
    }
  };

  const getCategories = async () => {
    setLoadMasterdata(false);
    try {
      let res = await ServiceWrapper.doGet( `${api_base_url}industry/${industryId}/category`, null, null, AuthManager.getGmsToken() );
      if (!res.errorfound) {
        setCategoriesList(res.data.data);
        setLoadMasterdata(true);
      } else {
        setLoadMasterdata(true);
      }
    } catch (error) {
      console.error("getCategories ~ error:", error)
    } finally {
      setLoadMasterdata(true);
    }
  }

  const getAttributes = async (categoryId) => {
    setLoadMasterdata(false);
    try {
      const res = await ServiceWrapper.doPost( `${api_base_url}get_attributes?page=1&limit=500`, {category_ids: [categoryId]}, null, AuthManager.getGmsToken() );
      setLoadMasterdata(true);
      if (!res.errorfound) {
        setLoading({ status: "Success", message: undefined });
        return res.data;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    } finally {
      setLoadMasterdata(true);
    }
  }

  const getAttributeValues = async (attributeId, target) => {
    try {
      setLoading({ status: "Loading", message: "Loading Products", });
      const endpoint = `${api_base_url}get_attribute_values?page=${paginationParams.pageNumber}&limit=${paginationParams.pageSize}`;
      const res = await ServiceWrapper.doPost(endpoint, { attribute_ids: [attributeId] }, null, AuthManager.getGmsToken());
      
      const response = res?.data?.data[0];
      const isLastPage = paginationParams?.pageNumber === response?.totalPages;
    
      if (isLastPage) {
        if (target === 'leftAttributeValues') {
          setHasMoreRow(false);
        } else if (target === 'rightAttributeValues') {
          setHasMoreColumn(false);
        }
      }
    
      const attributeValues = response?.attribute_values ?? [];
      const attributeValueCount = response?.attributeValueCount;
    
      setTotalRecords((prevRecords) => ({ ...prevRecords, [target]: attributeValueCount }));
    
      return attributeValues;
    } catch (error) {
      console.error("Error in getAttributeValues:", error);
      return [];
    } finally {
      setLoading({ status: "Success", message: undefined });
    }    
  }

  const setLeftAttribute = async (leftCategoryId) => {
    let leftAttributeList = await getAttributes(leftCategoryId);
    if (leftAttributeList.length === 0 ) {
      return;
    }
    if (ruleType === CBM_RULE) {
      setCBMOptions((prevState) => {
        return {
          ...prevState,
          leftCatAttributeSet: leftAttributeList?.data[0]?.attributes ?? [],
          leftCatID: selectedCategories.leftCategory.id,
          rightCatID: selectedCategories.rightCategory.id,
        };
      });
    } else {
      if (leftAttributeList && leftAttributeList?.data) {
        setAttributesList((prevState) => {
          return {
            ...prevState,
            leftAttributes: leftAttributeList?.data[0]?.attributes ?? [],
          };
        });
      }
    }
  }

  const setRightAttribute = async (rightCategoryId) => {
    let rightAttributeList = await getAttributes(rightCategoryId);
    if (rightAttributeList.length === 0) {
      return;
    }

    if (ruleType === CBM_RULE) {
      setCBMOptions((prevState) => {
        return {
          ...prevState,
          rightCatAttributeSet: rightAttributeList?.data[0]?.attributes ?? [],
          leftCatID: selectedCategories.leftCategory.id,
          rightCatID: selectedCategories.rightCategory.id,
        };
      });
    } else {
      if (rightAttributeList) {
        setAttributesList((prevState) => {
          return {
            ...prevState,
            rightAttributes: rightAttributeList?.data[0]?.attributes ?? [],
          };
        });
      }
    }
  }

  useEffect(() => {
    if (Utils.isUndefinedOrNull(industryId)) return;
    if (Utils.isUndefinedOrNull(ruleType)) return;
    setLoading({ status: "Success", message: undefined });
    const leftCategoryId = selectedCategories.leftCategory.id;
    const rightCategoryId = selectedCategories.rightCategory.id;

    if (CBMOptions.leftCatListOption === 'values' && !Utils.isUndefinedOrNull(leftCategoryId)) {
      if (CBMOptions.leftCatAttributeSet.length === 0) {
        setLeftAttribute(leftCategoryId);
      }
    }
    
    if (CBMOptions.leftCatListOption === 'products' && CBMOptions.isProductFilter !== undefined && CBMOptions.isProductFilter && !Utils.isUndefinedOrNull(leftCategoryId)) {
      if (CBMOptions.leftCatAttributeSet.length === 0) {
        setLeftAttribute(leftCategoryId);
      }
    }

    if (CBMOptions.leftCatListOption === 'values' && !Utils.isUndefinedOrNull(rightCategoryId)) {
      if (CBMOptions.rightCatAttributeSet.length === 0) {
        setRightAttribute(rightCategoryId);
      }
    }
    
    if (CBMOptions.leftCatListOption === 'products' && CBMOptions.isProductFilter !== undefined && CBMOptions.isProductFilter && !Utils.isUndefinedOrNull(rightCategoryId)) {
      if (CBMOptions.rightCatAttributeSet.length === 0) {
        setRightAttribute(rightCategoryId);
      }
    }

    if ((ruleType === CBI_RULE || ruleType === CBA_RULE) && !Utils.isUndefinedOrNull(leftCategoryId)) {
        setLeftAttribute(leftCategoryId);
    }

    if ((ruleType === CBI_RULE || ruleType === CBA_RULE) && !Utils.isUndefinedOrNull(rightCategoryId)) {
        setRightAttribute(rightCategoryId);
    }

    if (ruleType === CBM_RULE && CBMOptions.rightCatListOption === 'products' && !CBMOptions.isProductFilter && !Utils.isUndefinedOrNull(leftCategoryId) && !Utils.isUndefinedOrNull(rightCategoryId)) {
      setProducts(leftCategoryId, rightCategoryId);
    }

  }, [selectedCategories.leftCategory.id, selectedCategories.rightCategory.id, industryId, ruleType, paginationParams, CBMOptions.isProductFilter, CBMOptions.rightCatListOption]);

  useEffect(() => {
    if (shouldLoadProducts()) {
      const leftCategoryId = selectedCategories.leftCategory.id;
      const rightCategoryId = selectedCategories.rightCategory.id;
      setProducts(leftCategoryId, rightCategoryId);
    }
  }, [CBMOptions.rightAttributeValueId, CBMOptions.leftAttributeValueId, CBMOptions.leftValuesAttr, CBMOptions.rightValuesAttr, paginationParams, CBMOptions.leftCatListOption, CBMOptions.rightCatListOption, ruleType, CBMOptions.isProductFilter]);

  const setProducts = async (leftCategoryId, rightCategoryId) => {
    await load_left_product(leftCategoryId);
    await load_right_product(rightCategoryId);
    // if (hasMoreRow && !isPageNumberPresent('leftAttributeValues', paginationParams?.pageNumber)) {
    // if (hasMoreRow) {
    //   addToList('leftAttributeValues', paginationParams?.pageNumber);
    // }
    
    // if (hasMoreColumn && !isPageNumberPresent('rightAttributeValues', paginationParams?.pageNumber)) {
    // if (hasMoreColumn) {
    //   addToList('rightAttributeValues', paginationParams?.pageNumber);
    // }
  };

  const load_left_product = async (category_id) => {
    const payload = {
      filters: (CBMOptions.leftValuesAttr !== "" && CBMOptions.leftValuesAttr !== SELECT_ATTRIBUTE && CBMOptions.leftAttributeValueId !== "" ) ? 
        { "AttrValueId": CBMOptions.leftAttributeValueId, "attrID": CBMOptions.leftValuesAttr,} : 
      {}
    }
    const prod_list = await getProducts(category_id, payload, 'leftAttributeValues')
    setCBMOptions(prevState => { 
      return { 
        ...prevState, 
        leftCatProductList: prod_list
        //leftCatProductList: [...prevState.leftCatProductList, ...prod_list] 
      };
    });
  }

  const load_right_product = async (category_id) => {
    const payload = {
      filters: (CBMOptions.rightValuesAttr !== "" && CBMOptions.rightValuesAttr !== SELECT_ATTRIBUTE && CBMOptions.rightAttributeValueId !== "") ? 
        { "AttrValueId": CBMOptions.rightAttributeValueId, "attrID": CBMOptions.rightValuesAttr,} : 
      {}
    }
    const prod_list = await getProducts(category_id, payload, 'rightAttributeValues');
    setCBMOptions(prevState => { 
      return {  
        ...prevState, 
        rightCatProductList: prod_list
        //rightCatProductList: [...prevState.rightCatProductList, ...prod_list]
      };
    });
  }

  const getProducts = async (category_id, payload, target) => {
    try {
      setLoading({ status: "Loading", message: "Loading Products", });
      const prod_list_url = `${api_base_url}category/${category_id}/get_products?page=${paginationParams.pageNumber}&limit=${paginationParams.pageSize}`
      const productResponse = await ServiceWrapper.doPost( prod_list_url, CBMOptions.isProductFilter ? payload : {}, null, AuthManager.getGmsToken());

      if (!productResponse.errorfound && productResponse.data && productResponse.data.done === true) {
        setTotalRecords((prevRecords) => ({ ...prevRecords, [target]: productResponse.data.productCount }));
        const isLastPage = paginationParams?.pageNumber === productResponse?.data?.totalPages;
        if (isLastPage) {
          if (target === 'leftAttributeValues') {
            setHasMoreRow(false);
          } else if (target === 'rightAttributeValues') {
            setHasMoreColumn(false);
          }
        }
        return productResponse.data.data ?? [];
      } else {
        return [];
      }      
    } catch (error) {
      console.log(error);
    } finally {
      setLoading({ status: "Success", message: undefined });
    }
  }

  return (
    <RulesContext.Provider
      value={{
        ruleDispatch,
        ruleState,
        ruleType,
        setRuleType,
        categoriesList,
        categoryTypesList,
        selectedCategories,
        setSelectedCategories,
        selectedAttributes,
        setSelectedAttributes,
        attributesList,
        setAttributesList,
        setLoading,
        Loading,
        industryId,
        CBMOptions,
        setCBMOptions,
        loadMasterdata,
        totalRecords,
        setTotalRecords,
        paginationParams,
        setPaginationParams,
        cellStates,
        setCellStates,
        compatibilityData,
        setCompatibilityData,
        resetPageNumbersAndColumnAndRow,
        hasMoreColumn,
        setHasMoreColumn,
        hasMoreRow,
        setHasMoreRow,
        addToList,
        isPageNumberPresent,
        cbmRuleId,
        setCbmRuleId,
        initialRuleDetails,
        setInitialRuleDetails,
      }}
    >
      {children}
    </RulesContext.Provider>
  );
};